module.exports = "<div class=\"svg-container\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-shared-features/feature/shared-component/svg/svg.template.html
// module id = 673
// module chunks = 2